module.exports = __webpack_public_path__ + "static/media/detail-desc-img.2ebacb92.png";